export function discoveryItems(response) {
  if (Array.isArray(response)) return response;
  if (Array.isArray(response?.items)) return response.items;
  if (Array.isArray(response?.data)) return response.data;
  throw new Error('Invalid discovery response');
}

export function publicMusicUrl(kind, key) {
  if (!key || typeof key !== 'string') return '';
  return `https://${kind === 'artist' ? 'indiefy.me' : 'indfy.me'}/${encodeURIComponent(key)}?source=discover`;
}

export function streamingUrl(value) {
  try {
    const url = new URL(value);
    return ['https:', 'http:'].includes(url.protocol) && !url.username && !url.password ? url.href : '';
  } catch { return ''; }
}

export function spotifyEmbed(value) {
  try {
    const url = new URL(value);
    if (url.protocol !== 'https:' || url.hostname !== 'open.spotify.com') return '';
    const match = url.pathname.match(/^\/(?:intl-[a-z]+\/)?(album|track|playlist)\/([a-zA-Z0-9]+)\/?$/);
    return match ? `https://open.spotify.com/embed/${match[1]}/${match[2]}` : '';
  } catch { return ''; }
}

export function entityId(value) {
  return typeof value === 'object' ? value?._id : value;
}
